module.exports = __webpack_public_path__ + "static/media/12@960w.d1c85fbe.jpg";